/**
 * @generated SignedSource<<f83abe57810f737808a339bc3224294e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EditGasSupplier_getGasSupplierByIdQuery$variables = {
  id: string;
};
export type EditGasSupplier_getGasSupplierByIdQuery$data = {
  readonly getGasSupplierById: {
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string;
  };
};
export type EditGasSupplier_getGasSupplierByIdQuery = {
  response: EditGasSupplier_getGasSupplierByIdQuery$data;
  variables: EditGasSupplier_getGasSupplierByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "GasSupplierObjectType",
    "kind": "LinkedField",
    "name": "getGasSupplierById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditGasSupplier_getGasSupplierByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditGasSupplier_getGasSupplierByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b29cb6e68c43ea2a8a9b9be2decdf791",
    "id": null,
    "metadata": {},
    "name": "EditGasSupplier_getGasSupplierByIdQuery",
    "operationKind": "query",
    "text": "query EditGasSupplier_getGasSupplierByIdQuery(\n  $id: String!\n) {\n  getGasSupplierById(id: $id) {\n    id\n    name\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb595ddbbd44ddfadc79e71bb05c92e0";

export default node;
